<!-- Breadcrumb Header -->
<div class="mb-2">
  <div class="text-xl font-semibold mb-2">
    <span class="text-primary cursor-pointer text-lg text-500">User Management</span>
    <i class="pi pi-angle-right text-400 text-xs"></i>
    <span class="font-medium">New User</span>
  </div>
  <div class="font-montserrat text-303030 text-base font-normal lh-20">
    Configure user management settings below.
  </div>
</div>

<hr class="surface-border my-2" />

<div class="p-4 surface-card border-round shadow-1">

  <!-- Header -->
  <div class="flex justify-content-between align-items-center mb-3">
    <div>
      <div class="text-xl font-semibold">Add New User</div>
      <div class="text-sm text-500">Configure user permissions and access</div>
    </div>
  </div>

  <!-- ================= CREATE NEW USER FORM ================= -->
  <div class="border-1 surface-border border-round p-3 mb-4">

    <div class="text-lg font-medium mb-3">
      Create New User
    </div>

    <div class="grid formgrid">

      <!-- Login Email -->
      <div class="field col-12 md:col-6">
        <div class="flex flex-column flex-1">
          <label class="text-sm font-medium mb-1" for="Loginemail">Login Email</label>
          <input pInputText class="w-full" id="Loginemail" />
        </div>
      </div>

      <!-- Send Welcome Email -->
      <div class="field col-12 md:col-6 flex align-items-center gap-2 md:mt-4">
        <p-checkbox binary="true"></p-checkbox>
        <span class="text-sm">Send welcome email</span>
      </div>

      <!-- First Name -->
      <div class="field col-12 md:col-6">
        <div class="flex flex-column flex-1">
          <label class="text-sm font-medium mb-1" for="FirstName">First Name</label>
          <input pInputText class="w-full" id="FirstName" />
        </div>
      </div>

      <!-- Last Name -->
      <div class="field col-12 md:col-6">
        <div class="flex flex-column flex-1">
          <label class="text-sm font-medium mb-1" for="LastName">Last Name</label>
          <input pInputText class="w-full" id="LastName" />
        </div>
      </div>

      <!-- Reports To (Dropdown) -->
      <div class="field col-12 md:col-6">
        <div class="flex flex-column flex-1">
          <label class="text-sm font-medium mb-1" for="ReportsTo">Reports to</label>
          <p-dropdown
            id="ReportsTo"
            placeholder="Select"
            styleClass="w-full"
            appendTo="body">
          </p-dropdown>
        </div>
      </div>

      <!-- Assigned Campaigns (Dropdown) -->
      <div class="field col-12 md:col-6">
        <div class="flex flex-column flex-1">
          <label class="text-sm font-medium mb-1" for="AssignedCampaigns">Assigned Campaigns</label>
          <p-dropdown
            id="AssignedCampaigns"
            placeholder="Select"
            styleClass="w-full"
            appendTo="body">
          </p-dropdown>
        </div>
      </div>

      <!-- Department -->
      <div class="field col-12 md:col-6">
        <div class="flex flex-column flex-1">
          <label class="text-sm font-medium mb-1" for="Department">Department</label>
          <input pInputText class="w-full" id="Department" />
        </div>
      </div>

      <!-- Contact Email -->
      <div class="field col-12 md:col-6">
        <div class="flex flex-column flex-1">
          <label class="text-sm font-medium mb-1" for="ContactEmail">Contact email</label>
          <input pInputText class="w-full" id="ContactEmail" />
        </div>
      </div>

      <!-- Mobile Phone -->
      <div class="field col-12 md:col-6">
        <div class="flex flex-column flex-1">
          <label class="text-sm font-medium mb-1" for="MobilePhone">Mobile Phone</label>
          <input pInputText class="w-full" id="MobilePhone" />
        </div>
      </div>

      <!-- Location (Dropdown) -->
      <div class="field col-12 md:col-6">
        <div class="flex flex-column flex-1">
          <label class="text-sm font-medium mb-1" for="Location">Location</label>
          <p-dropdown
            id="Location"
            placeholder="Select"
            styleClass="w-full"
            appendTo="body">
          </p-dropdown>
        </div>
      </div>

      <!-- Default Campaign (Dropdown) -->
      <div class="field col-12 md:col-6">
        <div class="flex flex-column flex-1">
          <label class="text-sm font-medium mb-1" for="DefaultCampaign">Default Campaign</label>
          <p-dropdown
            id="DefaultCampaign"
            placeholder="Select"
            styleClass="w-full"
            appendTo="body">
          </p-dropdown>
        </div>
      </div>

      <!-- Title -->
      <div class="field col-12 md:col-6">
        <div class="flex flex-column flex-1">
          <label class="text-sm font-medium mb-1" for="Title">Title</label>
          <input pInputText class="w-full" id="Title" />
        </div>
      </div>

    </div>
  </div>


  <!-- ================= ACCORDION SECTIONS ================= -->
  <p-accordion [multiple]="true">

    <!-- GENERAL -->
    <p-accordionTab header="General">
      <div class="flex flex-wrap gap-4">

        <div class="flex align-items-center gap-2">
          <p-inputSwitch class="addusertoggle" [(ngModel)]="form.general.activeUser"></p-inputSwitch>
          <span class="text-sm">Active User</span>
        </div>

        <div class="flex align-items-center gap-2">
          <p-inputSwitch class="addusertoggle" [(ngModel)]="form.general.superAdmin"></p-inputSwitch>
          <span class="text-sm">Super Admin Access</span>
        </div>

      </div>
    </p-accordionTab>

    <!-- ACCESS -->
    <p-accordionTab header="Access">
      <div class="grid">

        <!-- Toggles -->
        <div class="col-12 md:col-6 flex align-items-center gap-2">
          <p-inputSwitch class="addusertoggle" [(ngModel)]="form.access.customersTab"></p-inputSwitch>
          <span class="text-sm">User can see customers tab</span>
        </div>

        <div class="col-12 md:col-6 flex align-items-center gap-2">
          <p-inputSwitch class="addusertoggle" [(ngModel)]="form.access.licrm"></p-inputSwitch>
          <span class="text-sm">LICRM Access</span>
        </div>

        <div class="col-12 md:col-6 flex align-items-center gap-2">
          <p-inputSwitch class="addusertoggle" [(ngModel)]="form.access.domo"></p-inputSwitch>
          <span class="text-sm">DOMO Enabled</span>
        </div>

        <!-- Dropdown: Reporting Level -->
        <div class="col-12 md:col-6">
          <div class="flex flex-column flex-1">
            <label class="font-semibold mb-1" for="ReportingLevel">Reporting Level</label>
            <p-dropdown
              id="ReportingLevel"
              [options]="reportingLevels"
              optionLabel="label"
              optionValue="value"
              placeholder="Select"
              styleClass="w-full"
              appendTo="body"
              [(ngModel)]="form.access.reportingLevel">
            </p-dropdown>
          </div>
        </div>

        <!-- Dropdown: Reporting Channels -->
        <div class="col-12 md:col-6">
          <div class="flex flex-column flex-1">
            <label class="font-semibold mb-1" for="ReportingChannels">Reporting Channels</label>
            <p-dropdown
              id="ReportingChannels"
              [options]="reportingChannels"
              optionLabel="label"
              optionValue="value"
              placeholder="Select"
              styleClass="w-full"
              appendTo="body"
              [(ngModel)]="form.access.reportingChannel">
            </p-dropdown>
          </div>
        </div>

      </div>
    </p-accordionTab>

    <!-- ORDER ENTRY -->
    <p-accordionTab header="Order Entry">
      <div class="grid">

        <div class="col-12 md:col-6 flex align-items-center gap-2">
          <p-inputSwitch class="addusertoggle" [(ngModel)]="form.order.complete"></p-inputSwitch>
          <span class="text-sm">User can complete orders</span>
        </div>

        <div class="col-12 md:col-6 flex align-items-center gap-2">
          <p-inputSwitch class="addusertoggle" [(ngModel)]="form.order.modify"></p-inputSwitch>
          <span class="text-sm">User can modify orders</span>
        </div>

        <div class="col-12 md:col-6 flex align-items-center gap-2">
          <p-inputSwitch class="addusertoggle" [(ngModel)]="form.order.salesperson"></p-inputSwitch>
          <span class="text-sm">User can change salesperson</span>
        </div>

        <div class="col-12 md:col-6 flex align-items-center gap-2">
          <p-inputSwitch class="addusertoggle" [(ngModel)]="form.order.editCustomer"></p-inputSwitch>
          <span class="text-sm">User can edit customer info</span>
        </div>

        <div class="col-12 md:col-6 flex align-items-center gap-2">
          <p-inputSwitch class="addusertoggle" [(ngModel)]="form.order.secureData"></p-inputSwitch>
          <span class="text-sm">Secure Data required</span>
        </div>

        <div class="col-12 md:col-6 flex align-items-center gap-2">
          <p-inputSwitch class="addusertoggle" [(ngModel)]="form.order.commercial"></p-inputSwitch>
          <span class="text-sm">Commercial exclusive</span>
        </div>

      </div>
    </p-accordionTab>

    <!-- RISK -->
    <p-accordionTab header="Risk">
      <div class="flex flex-row gap-3">

        <div class="flex align-items-center gap-2">
          <p-inputSwitch class="addusertoggle" [(ngModel)]="form.risk.atd"></p-inputSwitch>
          <span class="text-sm">ATD/TDV risk enabled</span>
        </div>

        <div class="flex align-items-center gap-2">
          <p-inputSwitch class="addusertoggle" [(ngModel)]="form.risk.ssn"></p-inputSwitch>
          <span class="text-sm">Require SSN on credit check</span>
        </div>

      </div>
    </p-accordionTab>

  </p-accordion>



  <!-- Footer Buttons -->
  <div class="flex justify-content-end gap-2 mt-4">
    <button pButton class="p-button-sm p-button-outlined" (click)="onCancel()">Cancel</button>
    <button pButton class="p-button-sm">SAVE CHANGES</button>
  </div>

</div>
